import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['keyInput', 'gifUrlInput', 'successIcon', 'errorIcon']

  connect() {
    this.loomSDKCallTimeout = null;
  }

  fetchGif() {
    let controller = this;

    $(this.element).block({
      message: '<i class="icon-spinner2 spinner"></i>',
      overlayCSS: {
        backgroundColor: '#fff',
        opacity: 0.8,
        cursor: 'wait'
      },
      css: {
        border: 0,
        padding: 0,
        backgroundColor: 'none'
      }
    });

    if (this.loomSDKCallTimeout) {
      clearTimeout(this.loomSDKCallTimeout);
    }

    this.loomSDKCallTimeout = setTimeout(function() {
      try {
        loomEmbedSDK.oembed(`https://www.loom.com/share/${controller.keyInputTarget.value}`).then(function(result) {
          if(result.thumbnail_url) {
            controller._fetchSuccess(result.thumbnail_url);
          } else {
            controller._fetchError();
          }
        }).catch(function () {
          controller._fetchError();
        })
      } catch(error) {
        controller._fetchError();
      }
    }, 1000)
  }

  _fetchSuccess(thumbnail_url) {
    this.gifUrlInputTarget.value = thumbnail_url.replace(/.gif$/, '-full-play.gif');

    if (this.hasSuccessIconTarget) {
      this.successIconTarget.classList.remove('hide');
      this.errorIconTarget.classList.add('hide');
    }

    $(this.element).unblock();
  }

  _fetchError() {
    if (this.hasSuccessIconTarget) {
      this.successIconTarget.classList.add('hide');
      this.errorIconTarget.classList.remove('hide');
    } else {
      new PNotify({ icon: 'icon-cross2', title: "Impossible de récupérer le GIF associé au Loom", type: 'error' });
    }

    $(this.element).unblock();
  }
}
